import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';

const regionalCenterColors = ["#413ea0", "#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884d8", "#82ca9d", "#d0743c"];

export default function StackedBarChartCustomConsultations411({data, keys, title, width, height}) {
    return (
        <div className="no-bullets" style={{width: width, maxWidth: "100%"}}>
            <h3>{title}</h3>
            <ResponsiveContainer width="100%" height={height}>
                <BarChart
                    data={data}
                    margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20,
                    }}
                >
                    <CartesianGrid stroke="#f5f5f5"/>
                    <XAxis dataKey="name"/>
                    <YAxis/>
                    <Tooltip/>
                    <Legend/>
                    {keys.map((key, index) => (
                        <Bar key={key} dataKey={key} stackId="consultations411"
                             fill={regionalCenterColors[index % regionalCenterColors.length]}/>
                    ))}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
